import { ShopStatus } from 'app/api/@generated/backend';

import { api } from 'app/api/common';

export class ShopStatusService {
    public static async getShopStatus(): Promise<ShopStatus> {
        return api.shopController.getShopStatus();
    }
}
